<template>
<div class="impressumContainer">
    <Header name="Impressum" />
    <div class="impressumContent">
        <p>
            <b>Herausgeber</b>
            <br/> Hessen Mobil
            <br/> Straßen- und Verkehrsmanagement
            <br/> Wilhelmstraße 10
            <br/> 65185 Wiesbaden
            <br/> Tel.: 0611 366-0
            <br/> Fax: 0611 366-34 35
            <br/> E-Mail: info@mobil.hessen.de
            <br/>
            <br/> Verantwortlich für den Inhalt i. S. d. § 55 Absatz 2 RStV
            <br/> Heiko Durth
            <br/> Präsident
            <br/>
            <br/>
            <img src="@/assets/images/de_cef_grau.png" width="100%" alt="eu-logo">
            <br/>
            <br/> <b>Ansprechpartner</b>
            <br/> Samuel Stefani
            <br/> Dezernat Verkehr
            <br/> Fachdezernat Verkehrsmanagement
            <br/> internet@mobil.hessen.de
            <br/>
            <br/> <b>Technischer Betrieb</b>
            <br/> TraffGo Road GmbH
            <br/> Ostwall 29
            <br/> 47798 Krefeld
            <br/> www.traffgoroad.com
            <br/>
            <br/> <b>Umsetzung</b>
            <br/> TraffGo Road GmbH
            <br/> Ostwall 29
            <br/> 47798 Krefeld
            <br/> www.traffgoroad.com
            <br/> info@traffgoroad.com
            <br/>
            <br/> <b>Urheberrecht </b>
            <br/> Die Gestaltung der Internetseiten sowie die inhaltlichen Beiträge sind urheberrechtlich geschützt.
            Dies gilt insbesondere für Texte, Bilder, Grafiken, Ton-, Video- oder Animationsdateien einschließlich
            deren Anordnung auf den Internetseiten. Veränderungen dürfen hieran nicht vorgenommen werden.
            Eine Vervielfältigung oder Verwendung von Inhalten dieser Internetseiten in anderen elektronischen
            oder gedruckten Publikationen oder deren Veröffentlichung (auch im Internet) ist nur nach vorheriger Zustimmung
            der Redaktionsleitung gestattet.
            <br/>
            <br/> <b>Ausnahmen:</b>
            <br/> 1. Einzelne Vervielfältigungen durch eine natürliche Person zum privaten Gebrauch sind im Rahmen
            des § 53 Urheberrechtgesetzes zulässig.
            <br/>
            <br/> 2. Zum Download angebotene Informationen (Broschüren, Formulare, Merkblätter und ähnliches) dürfen
            vervielfältigt und in körperlicher Form verbreitet werden. Insbesondere dürfen die zum Download angebotenen Informationen: auf einer Festplatte oder einem anderen
            <ul>
            <li>Speichermedium des Nutzers gespeichert werden, </li>
            <li>ausgedruckt werden elektronisch (z.B. per E-Mail), </li>
            <li>als Ausdruck oder auf einem Speichermedium weitergegeben werden. </li>
            </ul>
            Das öffentliche Zugänglichmachen für den
            interaktiven Abruf ist nicht gestattet. Insbesondere dürfen die zum Download angebotenen Informationen nicht
            auf einer Website öffentlich bereitgehalten werden oder anders im Internet zum Abruf zur Verfügung gestellt
            werden. Das Setzen eines Hyperlinks auf die zum Download angebotenen Informationen ist zulässig, wenn
            sichergestellt ist, dass der Link auf die jeweils aktuelle Version der Website innerhalb von www.mobil.hessen.de
            verweist.
            <br/>
            <br/> 3. Die Verbreitung und das öffentliche Zugänglichmachen von Pressemitteilungen ist mit
            Quellenangaben und Datum gestattet.
            <br/>
            <br/> <b>Rechte Dritter</b>
            <br/> An Bildern, Grafiken, Texten, Marken oder sonstigen Werken und Leistungen können ganz oder
            teilweise Rechte Dritter bestehen.
            <br/>
            <br/> <b>Haftungsausschluss</b>
            <br/> Die Nachrichten auf dieser Internetseite wurden mit der nach den Umständen gebotenen Sorgfalt
            auf Inhalt, Herkunft und Wahrheit geprüft. Es wird keine Gewähr für die Vollständigkeit, Richtigkeit
            oder Aktualität sowie die jederzeitige Verfügbarkeit der bereitgestellten Informationen übernommen.
            Eine Haftung für Schäden, die aus der Nutzung oder Nichtnutzung der auf dieser Internetseite angebotenen
            Informationen oder das Aufrufen oder Herunterladen von Daten oder die Installation oder Nutzung von
            heruntergeladener Software entstehen, wird- soweit gesetzlich zulässig - ausgeschlossen.
            <br/>
            <br/><b>Haftung für Links & Verweise</b>
            <br/> Diese Internetseite enthält Links zu Webseiten Dritter, auf deren Inhalt das Land Hessen
            keinen Einfluss hat. Durch diese Links wird lediglich den Zugang zur Nutzung fremder Inhalte nach
            § 8 Telemediengesetz ermöglicht.
            <br/>
            <br/> Die Redaktionsleitung hat bei der erstmaligen Verknüpfung mit einem anderen Internetangebot
            den fremden Inhalt daraufhin geprüft, ob durch ihn eine mögliche zivilrechtliche oder strafrechtliche
            Verantwortlichkeit ausgelöst wird. Sobald festgestellt wird, dass ein bestimmtes Angebot, zu dem ein Link
            bereitgestellt wurde, eine zivil- oder strafrechtliche Verantwortlichkeit auslöst, wird der Verweis auf
            dieses Angebot unverzüglich aufgehoben, soweit dies technisch möglich und zumutbar ist.
            <br/>
            <br/><b>Rechtswahl</b>
            <br/> Es gilt deutsches Recht.
            <br/>
            <br/>Unser Online-Angebot enthält Links zu Webseiten anderer Anbieter. Wir haben keinen Einfluss
            darauf, dass diese Anbieter die Datenschutzbestimmungen einhalten.
            <br/>
            <br/><b>Browser-Kompatibilität und Auflösung</b>
            <br/>Beim Einsatz unterschiedlicher Browser für das Internet und aufgrund unterschiedlicher
            Software-Einstellungen kann es bei der Darstellung der Daten zu Abweichungen kommen.
            <br/>Bei älteren Browser-Versionen kann es zu grafischen Abweichungen in der Anzeige von Schriften
            und Styles kommen. Wir bitten um Ihr Verständnis.
            <br/>
            <br/><b>Ändern der Schriftgröße</b>
            <br/>Sie haben die Möglichkeit, die Schriftgröße im Browser individuell an Ihre Sehgewohnheiten anzupassen.
            <br/>Beim Internet Explorer klicken Sie dazu auf den Menüpunkt "Ansicht", dann "Schriftgrad"
            und wählen dort die gewünschte Größe aus.
            <br/>Bei Mozilla Firefox können Sie über die Tastenkombinationen Strg + (vergrößern) bzw.
            Strg - (verkleinern) den Schriftgrad anpassen. Strg 0 bringt sie zur Normalansicht zurück.
            Diese Kombination funktioniert ebenfalls beim Internet Explorer.
            <br/>
            <br/><b>Barrierefreiheit</b>
            <br/>Bei der Gestaltung des Internet-Angebotes von Hessen Mobil wurden die Richtlinien der
            Verordnung zur Schaffung barrierefreier Informationstechnik nach dem Behindertengleichstellungsgesetz
            (Barrierefreie Informationstechnik-Verordnung - BITV) zugrunde gelegt. Bitte beachten Sie, dass die
            Kartendarstellungen ohne Javascript nicht funktionsfähig sind.
            <br/>
            <br/><b>Java / Java-Script</b>
            <br/>Große Teile unseres Angebots sind mit Hilfe von Java-Script umgesetzt. Für Nutzer, die in
            ihrem Browser Java-Script ausgeschaltet haben, ist der Service nicht ohne Einschränkungen nutzbar.
            <br/>
            <br/><b>Ausdrucken von Dokumenten</b>
            <br/>Druckfunktionen sind in diesem Angebot nicht vorgesehen.
            <br/>
            <br/><b>Cookies</b>
            <br/>Unsere Webseite nutzt Cookies. Lesen Sie hierzu auch unsere Hinweise zum Datenschutz.
        </p>
    </div>
</div>
</template>

<script>
import Header from './../CoreComponents/Header.vue';
export default {
  name: 'Impressum',
  components: { Header },
  computed: {
    device() {
      return this.$store.state.device;
    }
  },
  methods: {
    closeSidebar() {
      this.$emit('close');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.impressumContainer {
  width: 100%;
  height: 100%;
}

.impressumContent {
  height: calc(100% - 62.4px);
  overflow-y: auto;
}
</style>
